// 用于构造枚举字段管理对象
import {
  workFlowStatus,
  unitStatus,
  planStatus,
  riskColor,
  statusList,
  borrowList,
  planOpenStatus,
} from './enumTagType'

function enumManager(name, enums, value = 0) {
  const values = enums.map((item) => {
    return item.value
  })
  const index = values.indexOf(value)

  return enums[index].type
}

export const workFlowStatusTypes = (value) => {
  return enumManager('workFlowStatus', workFlowStatus, value)
}

export const unitStatusTypes = (value) => {
  return enumManager('unitStatus', unitStatus, value)
}

export const planStatusTypes = (value) => {
  return enumManager('planStatus', planStatus, value)
}

export const riskColorTypes = (value) => {
  return enumManager('riskColor', riskColor, value)
}

export const statusListTypes = (value) => {
  return enumManager('statusList', statusList, value)
}

export const borrowListTypes = (value) => {
  return enumManager('borrowList', borrowList, value)
}
